var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20, type: "flex", justify: "end" } },
        [
          _c(
            "el-col",
            { staticClass: "x-je", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "admin_name",
              label: _vm.$t("operator"),
              width: "100"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "type_name", label: _vm.$t("activityType") }
          }),
          _c("el-table-column", {
            attrs: { prop: "file", label: _vm.$t("configTable") }
          }),
          _c("el-table-column", {
            attrs: { prop: "config_id", label: _vm.$t("activityId") }
          }),
          _c("el-table-column", {
            attrs: { prop: "config", label: _vm.$t("activityConfig") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.listviewfileActivities.open(
                                row.config
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("view")))]
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "updated_at",
              label: _vm.$t("updateTime"),
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.updated_at) + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "created_at",
              label: _vm.$t("createTime"),
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.created_at) + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "120",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "controlsBtn",
                        on: {
                          click: function($event) {
                            return _vm.editingDi(row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("modify")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total,
          "page-size": _vm.paramsData.pageSize
        },
        on: { "size-change": _vm.sizeChange, "current-change": _vm.getList }
      }),
      _c("listviewfileActivities", { ref: "listviewfileActivities" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }